module.exports = __webpack_public_path__ + "smile dental temps.png?76a78290bed7f475f65ff239d4dc480f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/dental/smile dental temps.png
// module id = 59
// module chunks = 0